import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Announcements() {
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    api.get("/branches").then(({ data }) => setBranches(data));
    api.get("/departments").then(({ data }) => setDepartments(data));
  }, []);
  return (
    <ResourcePage
      endpoint="/announcements"
      testidPrefix="announcement"
      eyebrow="Communications"
      title="Announcements & Memos"
      subtitle="Company-wide, branch and department-level notices and circulars."
      ctaLabel="Post announcement"
      fields={[
        { name: "title", label: "Title", required: true },
        { name: "body", label: "Body", type: "textarea", required: true },
        { name: "audience", label: "Audience", type: "select", required: true, default: "company",
          options: ["company", "branch", "department"] },
        { name: "branch", label: "Branch (if branch-specific)", type: "select", options: branches.map((b) => b.name) },
        { name: "department", label: "Department (if dept-specific)", type: "select", options: departments.map((d) => d.name) },
      ]}
      columns={[
        { key: "title", label: "Title", render: (i) => (
          <div>
            <div className="font-medium text-gray-900">{i.title}</div>
            <div className="text-xs text-gray-500 line-clamp-2 max-w-md">{i.body}</div>
          </div>
        ) },
        { key: "audience", label: "Audience", render: (i) => <Badge tone="emerald">{i.audience}</Badge> },
        { key: "branch", label: "Branch" },
        { key: "department", label: "Department" },
        { key: "created_by_name", label: "Posted by" },
      ]}
      searchKeys={["title", "body", "branch", "department"]}
    />
  );
}
